import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      setConsentGiven(true);
      setShowConsent(false);
      // Make gtag available globally for other components
      window.cookieConsentGiven = true;
    } else {
      setShowConsent(true);
      window.cookieConsentGiven = false;
    }
    
    // Initialize on window load to ensure it's available
    if (typeof window !== 'undefined') {
      window.cookieConsentGiven = window.cookieConsentGiven || false;
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setConsentGiven(true);
    setShowConsent(false);
    window.cookieConsentGiven = true;
    
    // Track consent acceptance (only if gtag is available)
    if (window.gtag) {
      window.gtag('event', 'cookie_consent_accepted', {
        event_category: 'Privacy',
        event_label: 'User Accepted Cookie Consent',
        value: 1
      });
    }
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3 className="cookie-consent-title">Cookies and Privacy</h3>
          <p className="cookie-consent-description">
            This website uses cookies to ensure you get the best experience on our website. 
            If you continue browsing, you will be providing consent to our one of these.
          </p>
        </div>
        <button 
          className="cookie-consent-button" 
          onClick={handleAccept}
          aria-label="Accept cookies"
        >
          GOT IT
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;

